<div class="question-block" [formGroup]="form">

  <div class="question-header">
    <span class="question-counter">
      {{ index }} de {{ total }}
    </span>

    <h3 class="question-title">
      {{ question.question }}
    </h3>
  </div>

  <div class="question-actions">
    <div class="radio-group" role="radiogroup">
      <ion-radio-group
        [formControlName]="question.controlName"
        class="radio-group-respuesta"
        (ionChange)="activateQuestion()">
        <ion-item lines="none" class="radio-item">
          <ion-radio [value]="true" labelPlacement="end" justify="start">Sí</ion-radio>
        </ion-item>
        <ion-item lines="none" class="radio-item">
          <ion-radio [value]="false" labelPlacement="end" justify="start">No</ion-radio>
        </ion-item>
      </ion-radio-group>
    </div>

    <button
      *ngIf="!question.amountControl"
      type="button"
      class="details-toggle"
      (click)="toggleDetail()"
      [attr.aria-expanded]="detailsOpen">
      {{ detailsOpen ? 'Ocultar detalles' : 'Mostrar detalles' }}
      <span class="arrow" [class.open]="detailsOpen">
        <img class="arrow-icon" src="assets/icons/bottom-arrow.svg" alt="" />
      </span>
    </button>
  </div>

  <div
    *ngIf="detailsOpen && !question.amountControl"
    class="details"
    [innerHTML]="question.paragraph">
  </div>

  <app-preguntas-ingreso-extra
    *ngIf="question.amountControl"
    [form]="form"
    [question]="question"
    [index]="index"
    [total]="total"
    [isActive]="isActive"
    [resumenRefreshToken]="resumenRefreshToken"
    (saved)="onChildSave()">
  </app-preguntas-ingreso-extra>

</div>
